<template>
  <div :class="['row',className]" :style="{'padding-left': gutter+'rem','padding-right':gutter+'rem'}">
    <slot></slot>
  </div>
</template>

<script>
  export default{
    props:{
      className: {
      	type: String,
      	default: "flexStart"
      },
      gutter: {
        type: Number,
        default: 0
      }
    },
    data(){
      return{}
    }
  }
</script>

<style lang="scss" scoped="scoped">
  .row{
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/row/index.vue